// TODO: Create actions
export const Actions = {
    USPS_ZIP_INITIALIZE: 'USPS_ZIP_INITIALIZE',
    OPEN_LEAD_FORM_MODAL: 'OPEN_LEAD_FORM_MODAL',
    CDL_CHECKBOX_CHECKED: 'CDL_CHECKBOX_CHECKED',
    CDL_INITIAL_LEAD_FORM_CLICKED: 'CDL_INITIAL_LEAD_FORM_CLICKED',
    CDL_SUBMIT_LEAD_FORM_CLICKED: 'CDL_SUBMIT_LEAD_FORM_CLICKED',
    CLOSE_LEAD_FORM_MODAL: 'CLOSE_LEAD_FORM_MODAL',
    FAILED_TO_BUILD_DXG_SAVE_PAYLOAD: 'FAILED_TO_BUILD_DXG_SAVE_PAYLOAD',
    LEAD_FORM_SUBMITTED: 'LEAD_FORM_SUBMITTED',
    LEAD_FORM_FLOW_UPDATE: 'LEAD_FORM_FLOW_UPDATE',
    INITIAL_FORM_FLOW_UPDATE: 'INITIAL_FORM_FLOW_UPDATE',
    LEAD_FORM_SUBMISSION_SUCCESS: 'LEAD_FORM_SUBMISSION_SUCCESS',
    LEAD_FORM_SUBMISSION_FAILURE: 'LEAD_FORM_SUBMISSION_FAILURE',
    LEAD_FORM_CONTINUE_SUBMISSION: 'LEAD_FORM_CONTINUE_SUBMISSION',
    LEAD_FORM_FIRSTNAME_BLUR: 'LEAD_FORM_FIRSTNAME_BLUR',
    LEAD_FORM_LASTNAME_BLUR: 'LEAD_FORM_LASTNAME_BLUR',
    LEAD_FORM_EMAIL_BLUR: 'LEAD_FORM_EMAIL_BLUR',
    LEAD_FORM_PHONE_BLUR: 'LEAD_FORM_PHONE_BLUR',
    LEAD_FORM_MESSAGE_BLUR: 'LEAD_FORM_MESSAGE_BLUR',
    REINITIALIZE_LEAD_FORM: 'REINITIALIZE_LEAD_FORM',
    SET_LEAD_FORM_MODAL_ERROR: 'SET_LEAD_FORM_MODAL_ERROR',
    OFFER_SUBMISSION_FAILURE: 'OFFER_SUBMISSION_FAILURE',
    OFFER_SUBMISSION_SUCCESS: 'OFFER_SUBMISSION_SUCCESS',
    OFFER_SUBMISSION_REQUEST: 'OFFER_SUBMISSION_REQUEST',
    INIT_SUCCESS: 'INIT_SUCCESS',
    DEALXG_GET_SUCCESS: 'DEALXG_GET_SUCCESS',
    LEAD_FORM_ANALYTICS_ACTION: 'LEAD_FORM_ANALYTICS_ACTION',
    LEAD_FORM_CCPA: 'LEAD_FORM_CCPA',
    SP_DXG_SAVE_REQUEST: 'SP_DXG_SAVE_REQUEST',
    SP_DXG_SAVE_REQUEST_FAILURE: 'SP_DXG_SAVE_REQUEST_FAILURE',
    SP_DXG_SAVE_REQUEST_SUCCESS: 'SP_DXG_SAVE_REQUEST_SUCCESS',
    UPDATED_SHOPPER: 'UPDATED_SHOPPER',
    FETCH_QUESTIONS_OR_PAYMENT: 'FETCH_QUESTIONS_OR_PAYMENT',
    USPS_ZIP_REQUEST: 'USPS_ZIP_REQUEST',
    USPS_ZIP_FAILURE: 'USPS_ZIP_FAILURE',
    USPS_ZIP_SUCCESS: 'USPS_ZIP_SUCCESS',
    SUMMARY_REMOVE_TRADE_IN_CLICKED: 'SUMMARY_REMOVE_TRADE_IN_CLICKED',
    LEAD_FORM_SUBMIT_CLICKED: 'LEAD_FORM_SUBMIT_CLICKED',
    LEAD_FORM_CANCEL_CLICKED: 'LEAD_FORM_CANCEL_CLICKED',
    LEAD_FORM_SKIP_CLICKED: 'LEAD_FORM_SKIP_CLICKED',
    SET_IS_FROM_BUY_ONLINE_BUTTON: 'SET_IS_FROM_BUY_ONLINE_BUTTON',
    LEAD_FORM_SET_META: 'LEAD_FORM_SET_META'
};
